import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SecurityGroup } from '../models/security-group';
import { SecurityTargetElement } from '../models/security-target-element';
import { Settings } from './settings';
import { TargetElementMap } from "../models/target-element-map";
import { retry } from "rxjs/operators";

@Injectable({
	providedIn: 'root'
})
export class SecurityService {

	private readonly baseUrl = Settings.getInstance().BASE_URL + 'security';

	constructor(private http: HttpClient) { }

	public getAllActiveSecurityTargetElements(): Observable<SecurityTargetElement[]> {
		return this.http.get<SecurityTargetElement[]>(`${this.baseUrl}/ActiveSecurityTargetElements`);
	}

	public getAllSecurityGroups(): Observable<SecurityGroup[]> {
		return this.http.get<SecurityGroup[]>(`${this.baseUrl}/SecurityGroups`);
	}
	public createSecurityGroup(securityGroup: SecurityGroup):Observable<any> {
		return this.http.post(this.baseUrl + '/SecurityGroups/', securityGroup)
			.pipe(
				retry(1)
			);
	}
	public updateSecurityGroup(securityGroup: SecurityGroup): Observable<any> {
		return this.http.put(this.baseUrl + '/SecurityGroups/' + securityGroup.id, securityGroup)
		 	.pipe(
				retry(1)
			);
	}
	public deleteSecurityGroup(id: number): Observable<any> {
		return this.http.delete(this.baseUrl + '/SecurityGroups/' + id)
		.pipe(
			retry(1)
		);
	}
	public getAllActiveSecurityGroups(): Observable<SecurityGroup[]> {
		return this.http.get<SecurityGroup[]>(`${this.baseUrl}/ActiveSecurityGroups`);
	}
	public getAllSecurityTargetElements(): Observable<SecurityTargetElement[]> {
		return this.http.get<SecurityTargetElement[]>(`${this.baseUrl}/AllSecurityTargetElements`);
	}
	public getSecurityTargetElementsJSON(): Observable<any> {
		return this.http.get<SecurityGroup[]>(`${this.baseUrl}/SecurityTargetElementsJSON`);
	}
	public getSecurityAccessMap(calledFrom: string): Observable<any> {
		return this.http.get<TargetElementMap[]>(`${this.baseUrl}/SecurityAccessMap/${calledFrom}`);
	}
	public getSecurityTargetElementsBySecurityGroup(groupId: number): Observable<{ id: number; name: string; code: string; parentId: number; rightType: string }[]> {
		return this.http.get<SecurityTargetElement[]>(`${this.baseUrl}/SecurityTargetElementsBySecurityGroup/${groupId}`);
	}
	public getSecurityGroupsByUser(userId: number): Observable<{ id: number; name: string }[]> {
		return this.http.get<SecurityGroup[]>(`${this.baseUrl}/SecurityGroupsByUser/${userId}`);
	}
	public getSecurityTargetElementsByUser(userId: number): Observable<{ id: number; name: string; code: string; parentId: number; rightType: string }[]> {
		return this.http.get<SecurityTargetElement[]>(`${this.baseUrl}/SecurityTargetElementsByUser/${userId}`);
	}
	public updateSecurityTargetElementsbySecurityGroup(groupId: number, targetElements: SecurityGroup[]): Observable<any> {

		return this.http.put(this.baseUrl + '/SecurityTargetElementsBySecurityGroup/' + groupId, targetElements)
			.pipe(
				retry(1)
			);
	}
	public updateSecurityTargetElementsbyUser(userId: number, targetElements: SecurityGroup[]): Observable<any> {

		return this.http.put(this.baseUrl + '/SecurityTargetElementsByUserId/' + userId, targetElements)
			.pipe(
				retry(1)
			);
	}
	public updateSecurityTargetElement(record: SecurityTargetElement): Observable<any> {
		return this.http.put(`${this.baseUrl}/SecurityTargetElements`, record).pipe(
			retry(1)
		);
	}
	public createUserSecurityGroupMaps(userId: number, userSecurityGroupMapList): Observable<any> {
		return this.http.put(this.baseUrl + '/SecurityGroupsByUser/' + userId, userSecurityGroupMapList)
		.pipe(
			retry(1)
		);
	}
}
